import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import { useAppContext } from '@at/sauron-platform-core/lib/app/app-context.hoc';
import { ZendeskChat } from './zendesk/zendesk-chat';
import { LivePersonChat } from './live-person/live-person-chat';
function shouldUseZendeskChat(alwaysUseZendeskChat, enableZendeskScriptWithBucket, abTestGroups) {
    return (alwaysUseZendeskChat || (enableZendeskScriptWithBucket && abTestGroups.includes(enableZendeskScriptWithBucket)));
}
/**
 * If useZendesk is true OR if abTestGroups contains useZendeskOnlyIfUserInTestBucketOf
 * and useLivePersonIfNotUsingZendesk is true
 *
 * This is to check and protect against users trying to load both Zendesk and Live Person scripts on the page.
 *
 * NOTE: We check the abTestGroups as this could be set to 0% traffic so a user may request to fall back
 * to Live Person to load its script.
 */
function bothZendeskAndLivePersonChatScriptsAreRequested(useZendesk, useLivePersonIfNotUsingZendesk) {
    return useZendesk && useLivePersonIfNotUsingZendesk;
}
export function AutoTraderSupportChatScript({ useZendesk = false, useZendeskOnlyIfUserInTestBucketOf = undefined, userIsSignedIn = false, useLivePersonIfNotUsingZendesk = false, }) {
    const { abTestGroups } = useAppContext();
    if (bothZendeskAndLivePersonChatScriptsAreRequested(useZendesk, useLivePersonIfNotUsingZendesk)) {
        console.error('Both Zendesk and Live Person AT Support Chat scripts were asked to be loaded from the AutoTraderSupportChatScript component.' +
            '\n' +
            'Only one can be used to talk to AT Support. Please check your configuration of the AutoTraderSupportChatScript component');
        return _jsx(Fragment, {});
    }
    return shouldUseZendeskChat(useZendesk, useZendeskOnlyIfUserInTestBucketOf, abTestGroups) ? (_jsx(ZendeskChat, { userIsSignedInOnJourney: userIsSignedIn })) : useLivePersonIfNotUsingZendesk ? (_jsx(LivePersonChat, {})) : (_jsx(Fragment, {}));
}
